class ParticipantsExport {
    constructor() {
        this.Selectors = {
            exportOrderTable: '#exportParticipantsOptionsTable',
                exportFieldsSelectBoxList: '.exportFieldSelectBoxList',
                exportFieldsSelectBox: '.exportFieldsSelectBox',
                exportFieldTemplate: '#export-field-template',
                exportOrderInput: '#export-order'
        };

        this.$exportOrderTable = $(this.Selectors.exportOrderTable);
        let $exportFieldsSelectBoxList = $(this.Selectors.exportFieldsSelectBoxList);

        if(!this.$exportOrderTable.length) return;

        let $exportFieldTemplate = $(this.Selectors.exportFieldTemplate);
        $exportFieldTemplate.remove();
        this.$exportOrderTable.DataTable().columns().every(function( index ) {
            let $header = $(this.column(index).header());
            let $exportField = $exportFieldTemplate.clone();
            $exportField.find('input').attr('name', $exportField.find('input').attr('name') + '[' + $header.data('orderFieldName') + ']');
            $exportField.find('input').attr('value', index);
            $exportField.find('input').prop('checked', true);
            $exportField.find('span').text($header.text().trim());

            $exportFieldsSelectBoxList.append($exportField);
        });

        this.onDataTablesOrder();
        this.exportOrderTableReorder();
        this.exportFieldsSelectBoxClick();
        this.exportOrder();
    }

    onDataTablesOrder() {
        let $order = this.$exportOrderTable.DataTable().order()[0],
            $orderField = $(this.$exportOrderTable.DataTable().column($order[0]).header()).data('orderFieldName');
        $(this.Selectors.exportOrderInput).val($orderField + ',' + $order[1]);
    }

    exportOrderTableReorder() {
        let $exportFieldsSelectBox = $(this.Selectors.exportFieldsSelectBox);

        this.$exportOrderTable.DataTable().on('column-reorder', function(e, settings, details) {
            $exportFieldsSelectBox.each(function(index, element) {
                $(element).val(details.mapping[$(this).val()]);
            });
        });
    }

    exportFieldsSelectBoxClick() {
        let $exportFieldsSelectBox = $(this.Selectors.exportFieldsSelectBox);
        $exportFieldsSelectBox.on('change', function(event) {
            let column = this.$exportOrderTable.DataTable().column($(event.target).val());
            column.visible( $(event.target).is(':checked') );
            this.$exportOrderTable.css('width', '');
        }.bind(this));
    }

    exportOrder() {
        this.$exportOrderTable.on('order.dt', function(event) {
            this.onDataTablesOrder();
        }.bind(this));
    }
}

export default ParticipantsExport;